module.exports = __webpack_public_path__ + "static/media/ico_simulation_skin_texture.4f4852e1.png";